module.exports = __webpack_public_path__ + "static/thumb-construction-d5c9531c9a3dcbcfff7e0ff65e6e284b.png";